module.exports = __webpack_public_path__ + "img/full5-min.edc6d357.png";